import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Asset } from '@app/core/model/entities/asset/asset';
import { ContractInput } from '@app/core/model/entities/asset/contract';
import {
  OrganizationContractCreateModalComponent
} from '@app/features/main/views/organization-contracts/modal/organization-contract-create-modal/organization-contract-create-modal.component';

@Component({
  templateUrl: './contract-create-modal.component.html',
  standalone: false
})
export class ContractCreateModalComponent extends OrganizationContractCreateModalComponent {
  private readonly asset = inject<{ asset: Asset; }>(MAT_DIALOG_DATA).asset;
  public formId = 'asset_contract_creation_dialog';

  /**
   * Data from the filled form.
   * @return Equipment data.
   */
  public getGeneratedObject(): ContractInput {
    return {
      ...this.contractInput,
      assetId: this.asset.id
    };
  }
}
